import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=65b589d2&lang=scss&scoped=true"

import exportComponent from "E:\\Zwen\\Project\\公司\\车妙净H5\\project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b589d2"]])

export default __exports__